import React from 'react';
import PropTypes from 'prop-types';
import SVGInline from 'react-svg-inline'

import { shortenStr } from '../../../../utils';

// components

// svgs
import phoneSVG from '../../../inlineSVGs/phoneSVG';
import linkSVG from '../../../inlineSVGs/linkSVG';
import mailSVG from '../../../inlineSVGs/mailSVG';
import fbLinkWhiteSVG from '../../../inlineSVGs/fbLinkWhiteSVG';


// styles
import './Contact.css';

const Contact = ({ info, type, wrapperStyle }) => {

    const renderPhone = () => {
        if (!info.phone) return null;

        return (
            <a href={`tel:${info.phone}`} className={`line-wrapper phone-wrapper ${type}`}>
                <SVGInline className="icon" svg={phoneSVG} component="i" />
                <p>{info.phone}</p>
            </a>
        )
    };

    const renderLink = () => {
        if (!info.link) return null;

        return (
            <a href={info.link}  rel="noopener noreferrer" target="_blank" className={`line-wrapper link-wrapper ${type}`}>
                <SVGInline className="icon" svg={linkSVG} component="i"/>
                <p>{shortenStr(info.link, 35)}</p>
            </a>
        )
};

    const renderEmail = () => {
        if (!info.email) return null;

        return (
            <a href={`mailto:${info.email}`} className={`line-wrapper email-wrapper ${type}`}>
                <SVGInline className="icon" svg={mailSVG} component="i"/>
                <p>{shortenStr(info.email, 35)}</p>
            </a>
        )
    };

    const renderFbLink = () => {
        if (!info.fblink) return null;

        const fbLink = info.fblink.toLowerCase();

        const arr = fbLink.split('/');

        let fbProfileName = fbLink.length > 35 ? `${fbLink.substring(0, 35)}...` : fbLink;

        if (arr[arr.length - 1].includes('.')) fbProfileName = arr[arr.length - 1].replace('.', ' ');

        return (
            <div className={`line-wrapper ${arr[arr.length - 1].includes('.') ? 'fb-link-wrapper' : ''} ${type}`} onClick={() => window.open(info.fblink, '_blank')}>
                <SVGInline className="icon" svg={fbLinkWhiteSVG} component="i"/>
                <p>{fbProfileName}</p>
            </div>
        )
    };

    if (!info) return null;

    return (
        <div className="modal-contact-wrapper rtl" style={wrapperStyle}>
            {renderPhone()}
            {renderLink()}
            {renderEmail()}
            {renderFbLink()}

        </div>
    )
};

Contact.propTypes = {
    info: PropTypes.object,
    type: PropTypes.string,
    wrapperStyle: PropTypes.object
};

export default Contact;



// WEBPACK FOOTER //
// ./src/Components/ModalsNew/ModalElements/Contact/Contact.js